'use strict';

angular.module('broadcastsModule')

.config(function (modalStateProvider)
{
    modalStateProvider.state('admin.broadcasters.basket', {
        url: '/basket/{id:[0-9\w-]+}',
        templateUrl: 'broadcasters/broadcasters.modals/broadcasters.basket.modal.html',
        controller: 'BroadcastsBasketModalController',
        resolve: {
            model: ['BroadcastsAsset', 'modalState', function (BroadcastsAsset, modalState)
            {
                return BroadcastsAsset.find(modalState.stateParams.id);
            }],
            files: ['BroadcastsFile', 'modalState', function (BroadcastsFile, modalState)
            {
                const params = {broadcast_id: modalState.stateParams.id};
                BroadcastsFile.ejectAll(params);

                return BroadcastsFile.findAll(params);
            }]
        }
    });
});
